<template>
  <div>

    <error-msg :data="{msg: 'Není aktivní žádná objednávka'}" />

  </div>
</template>

<script>
  import ErrorMsg from './Error';

  export default {
    props: {},
    components: {
      ErrorMsg
    }
  }
</script>

<style scoped>
</style>
